import React, { Component } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { connect } from "../../utils"
// import Media from "./Media"
import { AnimationImage } from "./animation"

class ImageView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      widthElement: 0,
    }
  }
  componentDidMount() {
    // const { id, layoutState } = this.props
    // const { animation } = layoutState.getItemJS(id).props.values
    if (this.refs.imageView) {
      const elementWidth = ReactDOM.findDOMNode(
        this.refs.imageView
      ).getBoundingClientRect().width
      this.setState({
        widthElement: elementWidth,
      })
    }
    // if (animation && animation.show) {
    //   if (this.refs.imageView) {
    //     const elementWidth = ReactDOM.findDOMNode(
    //       this.refs.imageView
    //     ).getBoundingClientRect().width
    //     this.setState({
    //       widthElement: elementWidth,
    //     })
    //   }
    // }
  }

  renderWithLink(animation, srcImage, altText, width, href) {
    if (animation && animation.show) {
      return (
        <a href={href.url} target={href.target}>
          <AnimationImage
            src={srcImage}
            altText={altText}
            widthImage={width}
            animation={animation}
          />
        </a>
      )
    }
    return (
      <a href={href.url} target={href.target}>
        <Image
          src={srcImage}
          alt={altText}
          style={{ width: width, height: "100%" }}
        />
      </a>
    )
  }
  renderImage(animation, srcImage, altText, width, isLink, href) {
    if (isLink) {
      return this.renderWithLink(animation, srcImage, altText, width, href)
    }

    if (animation && animation.show) {
      return (
        <AnimationImage
          src={srcImage}
          altText={altText}
          widthImage={width}
          animation={animation}
        />
      )
    }
    return (
      <Image
        src={srcImage}
        alt={altText}
        style={{ width: width, height: "100%" }}
      />
    )
  }
  render() {
    const { id, layoutState } = this.props
    const {
      containerPadding,
      imageUrl,
      align,
      altText,
      width,
      animation,
      href,
    } = layoutState.getItemJS(id).props.values
    let srcMobile =
      imageUrl.urlMobile ||
      imageUrl.url ||
      "https://via.placeholder.com/400x400?text=CMS"
    let srcDesktop =
      imageUrl.url ||
      imageUrl.urlMobile ||
      "https://via.placeholder.com/600x600?text=CMS"
    // console.log(layoutState.getItemJS(id).props.values);
    const isLink = href && href.url !== "" ? true : false
    // console.log("image", this.state.widthElement)
    return (
      <div
        ref="imageView"
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "auto",
          display: "flex",
          width: "100%",
          padding: containerPadding,
          flex: 1,
          justifyContent: align,
        }}
      >
        {this.state.widthElement <= 320
          ? this.renderImage(animation, srcMobile, altText, width, isLink, href)
          : this.renderImage(
              animation,
              srcDesktop,
              altText,
              width,
              isLink,
              href
            )}
        {/* {<Media query='(max-width: 768px)'>
    {matches =>
      matches ? this.renderImage(animation, srcMobile, altText, width, isLink, href ) :  this.renderImage(animation, srcDesktop, altText, width, isLink, href)  }
  </Media>} */}
      </div>
    )
  }
}
/**<Image src={srcDesktop} alt={altText} style={{width:width, height:'100%'}} /> */
const Image = styled.img`
  opacity: 1;
  display: block;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
`

export default connect("layoutState")(ImageView)



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/ImageView.js